import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
/* eslint-disable */
import React, { useState, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { NavLink, useLocation } from 'react-router-dom';
import { useHistory, } from 'react-router-dom';
import { ExternalHeaderLink, ExternalLink } from './LinkDom';
import LogoPng from '../assets/header/Logo.png';
import mobileLogo from '../assets/header/mobileLogo.png';
import down from '../assets/header/down.svg';
import jump from '../assets/header/jump.svg';
import jump_hover from '../assets/header/jump_hover.svg';
import hartGif from '../assets/header/hart.gif';
import { MobileShowContainer, PcShowContainter } from './GlobalStyle';
import { Drawer } from 'antd';
import { useConnectModal, useChainModal } from '@rainbow-me/rainbowkit';
import { useAccount } from 'wagmi';
import { walletConfig } from './walletManager/walletConfig';
import { instance } from '../index';
import AccountModel from './accountModel';
import WalletPNG from '../assets/image/header/wallet@2x.png';
import WrongPNG from '../assets/image/header/wrong@2x.png';
function buildNavRouter(t) {
    return [
        {
            name: t('nav.nexus'),
            pathUrl: 'Nexus',
        },
        {
            name: t('nav.agentOS'),
            pathUrl: 'AgentOS',
        },
        {
            name: t('nav.payments'),
            pathUrl: 'payments',
        },
        {
            name: t('nav.build'),
            className: 'build',
            childPaths: [
                {
                    name: t('build.netxscan'),
                    link: 'https://netxscan.io/',
                    introText: t('build.netxscanIntro'),
                    showRightPoint: true,
                },
                {
                    name: t('build.faucet'),
                    link: 'https://netx.world/faucet',
                    introText: t('build.faucetIntro'),
                    target: '_self',
                },
                {
                    name: t('build.bridge'),
                    pathUrl: 'bridge',
                    introText: t('build.bridgeIntro'),
                },
            ]
        },
        {
            name: t('nav.participate'),
            className: 'participate',
            childPaths: [
                {
                    name: t('participate.exchange'),
                    pathUrl: 'exchange',
                    introText: t('participate.exchangeIntro'),
                },
                {
                    name: t('participate.aiEngineer'),
                    pathUrl: 'AI_engineer',
                    introText: t('participate.aiEngineerIntro'),
                },
                {
                    name: t('participate.partnership'),
                    pathUrl: 'partnership',
                    introText: t('participate.partnershipIntro'),
                },
                {
                    name: t('participate.genesisBundle'),
                    pathUrl: 'Genesis_Bundle',
                    introText: t('participate.genesisBundleIntro'),
                    isHot: true
                },
            ]
        },
        {
            name: t('nav.learn'),
            className: 'learn',
            childPaths: [
                {
                    name: t('learn.technology'),
                    pathUrl: 'technology',
                    introText: t('learn.technologyIntro'),
                },
                {
                    name: t('learn.whitepaper'),
                    link: 'https://netx.gitbook.io/netx-docs/whitepaper/netx-enterprise-framework-nef',
                    introText: t('learn.whitepaperIntro'),
                    showRightPoint: true,
                },
                {
                    name: t('learn.economy'),
                    pathUrl: 'economy',
                    introText: t('learn.economyIntro'),
                },
                {
                    name: t('learn.roadmap'),
                    link: 'https://netx.gitbook.io/netx-docs/roadmap',
                    introText: t('learn.roadmapIntro'),
                    showRightPoint: true,
                },
                {
                    name: t('learn.tokenRelease'),
                    pathUrl: 'token-release',
                    introText: t('learn.tokenReleaseIntro'),
                },
                {
                    name: t('learn.brandResources'),
                    link: 'https://netx.gitbook.io/netx-docs/brand-resources',
                    introText: t('learn.brandResourcesIntro'),
                    showRightPoint: true,
                },
                {
                    name: t('learn.trustedComputing'),
                    pathUrl: 'trusted_computing',
                    introText: t('learn.trustedComputingIntro'),
                },
                {
                    name: t('learn.communityResearch'),
                    pathUrl: 'research',
                    introText: t('learn.communityResearchIntro'),
                },
            ]
        },
    ];
}
/** 按路径段匹配 slug，避免 /AI_engineer 误匹配 AI */
function pathnameMatchesSlug(pathname, slug) {
    if (!slug)
        return false;
    const segments = pathname.split('/').filter(Boolean);
    return segments.includes(slug);
}
let n = 0;
const HotGIF = styled.img `  width: 0.28rem;  height: 0.28rem;  position: relative;  top: -0.05rem;`;
const HartGif = styled.img `  width: 20rem;  height: 20rem;  object-fit: contain;`;
// 钱包状态枚举
var walletState;
(function (walletState) {
    walletState[walletState["connected"] = 0] = "connected";
    walletState[walletState["wrongNetwork"] = 1] = "wrongNetwork";
    walletState[walletState["disconnected"] = 2] = "disconnected";
})(walletState || (walletState = {}));
export default function NavHeader(props) {
    const history = useHistory();
    const location = useLocation();
    const { t, i18n } = useTranslation('nav');
    const currentLang = i18n.language?.toLowerCase().startsWith('ja') ? 'ja' : 'en';
    const NavRouter = buildNavRouter(t);
    const [scrolled, setScrolled] = useState(false);
    const [langOpen, setLangOpen] = useState(false);
    const [mobileLangOpen, setMobileLangOpen] = useState(false);
    const switchLang = (lang) => {
        i18n.changeLanguage(lang);
        localStorage.setItem('netx-lang', lang);
        window.dispatchEvent(new CustomEvent('netx-lang-change', { detail: lang }));
    };
    const [showMennu, setshowMennu] = useState(false);
    const [NavRouterList, setNavRouterList] = useState(NavRouter);
    // 钱包相关状态
    const { openConnectModal } = useConnectModal();
    const { openChainModal } = useChainModal();
    const account = useAccount();
    const app = instance.root;
    const { _useActions } = app;
    const { setAccount, setSignation } = _useActions();
    const [walletStatus, setWalletStatus] = useState(walletState.disconnected);
    const [openWalletInfo, setOpenWalletInfo] = useState(false);
    const [isSigned, setIsSigned] = useState(false);
    // 使用 ref 防止重复触发签名（解决 React StrictMode 双重渲染问题）
    const isSigningRef = useRef(false);
    const lastSignedAddressRef = useRef(null);
    const supportedChainIds = walletConfig.chains.map((item) => item.id);
    const SignStr = 'www.netx.world';
    const handleScroll = () => {
        if (window.scrollY > 0) {
            setScrolled(true);
        }
        else {
            setScrolled(false);
        }
    };
    useEffect(() => {
        handleScroll();
        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);
    // 处理钱包连接状态
    useEffect(() => {
        if (account && !account.isConnected) {
            setAccount(null);
            setSignation(null);
            setWalletStatus(walletState.disconnected);
            setIsSigned(false);
            lastSignedAddressRef.current = null;
            isSigningRef.current = false;
        }
        else if (account && account.isConnected) {
            setAccount(account);
            if (account.chainId && !supportedChainIds.includes(account.chainId)) {
                setWalletStatus(walletState.wrongNetwork);
                lastSignedAddressRef.current = null;
                isSigningRef.current = false;
            }
            else {
                setWalletStatus(walletState.connected);
                // 防止重复触发签名（解决 React StrictMode 双重渲染问题）
                const currentAddress = account.address || null;
                if (isSigningRef.current && lastSignedAddressRef.current === currentAddress) {
                    // 正在处理同一地址的签名，跳过
                    return;
                }
                // 检查签名是否已存在且地址匹配
                const storedSignature = localStorage.getItem('signature');
                const storedAddress = localStorage.getItem('signedAddress');
                // 如果地址变化或签名不存在，才触发签名
                if (currentAddress && (!storedSignature || storedAddress !== currentAddress)) {
                    // 标记正在处理签名，防止重复触发
                    isSigningRef.current = true;
                    lastSignedAddressRef.current = currentAddress;
                    handleVerifySign();
                }
                else if (currentAddress) {
                    // 签名已存在且地址匹配，更新 ref
                    lastSignedAddressRef.current = currentAddress;
                    isSigningRef.current = false;
                }
            }
        }
        else {
            setWalletStatus(walletState.disconnected);
            lastSignedAddressRef.current = null;
            isSigningRef.current = false;
        }
    }, [account?.address, account?.chainId, account?.isConnected]);
    // 验证签名
    const handleVerifySign = () => {
        if (!account?.address)
            return;
        let signature = localStorage.getItem('signature');
        const storedAddress = localStorage.getItem('signedAddress');
        // 如果签名存在且地址匹配，验证签名
        if (signature && storedAddress === account.address) {
            app.emit('WalletPilet.VerifyMessage', {
                address: account.address,
                message: SignStr,
                signature: signature
            });
        }
        else {
            // 地址变化或签名不存在，需要重新签名
            app.emit('WalletPilet.SignMsg', { msg: SignStr });
        }
    };
    // 监听签名事件
    useEffect(() => {
        const handleSignedMsg = (arg) => {
            if (arg.state === "success") {
                localStorage.setItem('signature', arg.result);
                // 保存签名对应的地址，用于后续验证
                if (account?.address) {
                    localStorage.setItem('signedAddress', account.address);
                    lastSignedAddressRef.current = account.address;
                }
                setSignation(arg.result);
                setIsSigned(true);
                setWalletStatus(walletState.connected);
                // 签名完成，重置标志
                isSigningRef.current = false;
            }
            else {
                setIsSigned(false);
                localStorage.setItem('signature', '');
                localStorage.setItem('signedAddress', '');
                localStorage.setItem('AUTHORIZATION', '');
                lastSignedAddressRef.current = null;
                isSigningRef.current = false;
            }
        };
        const handleVerifyMessageEmit = (arg) => {
            if (arg.result) {
                setSignation(localStorage.getItem('signature'));
                setIsSigned(true);
                setWalletStatus(walletState.connected);
                // 验证成功，更新 ref
                if (account?.address) {
                    lastSignedAddressRef.current = account.address;
                }
                isSigningRef.current = false;
            }
            else {
                setIsSigned(false);
                localStorage.setItem('signature', '');
                localStorage.setItem('signedAddress', '');
                localStorage.setItem('AUTHORIZATION', '');
                lastSignedAddressRef.current = null;
                // 验证失败，需要重新签名
                if (account?.address && !isSigningRef.current) {
                    // 防止重复触发
                    isSigningRef.current = true;
                    lastSignedAddressRef.current = account.address;
                    app.emit('WalletPilet.SignMsg', { msg: SignStr });
                }
            }
        };
        app.on('WalletPilet.SignedMsg', handleSignedMsg);
        app.on('WalletPilet.VerifyMessageEmit', handleVerifyMessageEmit);
        return () => {
            app.off('WalletPilet.SignedMsg', handleSignedMsg);
            app.off('WalletPilet.VerifyMessageEmit', handleVerifyMessageEmit);
        };
    }, [account?.address]);
    // 处理连接钱包
    const handleConnectWallet = () => {
        if (walletStatus === walletState.wrongNetwork) {
            openChainModal();
        }
        else {
            openConnectModal();
        }
    };
    // 获取当前链图标
    const getCurrentNetworkIcon = () => {
        if (account?.chainId) {
            const chain = walletConfig.chains.find((item) => item.id === account.chainId);
            return chain?.icon;
        }
        return null;
    };
    // 格式化地址
    const formatAddress = (address) => {
        if (!address)
            return '';
        return address.substring(0, 6) + '...' + address.substring(address.length - 4, address.length);
    };
    const resetMobileNav = () => {
        setNavRouterList(NavRouter.map((item) => ({ ...item, flag: false })));
    };
    const openMobileMenu = () => {
        setshowMennu(true);
        resetMobileNav();
    };
    const closeMobileMenu = () => {
        setshowMennu(false);
        resetMobileNav();
    };
    const toggleMobileMenuItem = (index) => {
        setNavRouterList((items) => items.map((item, itemIndex) => itemIndex === index ? { ...item, flag: !item.flag } : item));
    };
    const getMobileChildPaths = (item) => {
        if (!item.childPaths) {
            return [];
        }
        if (item.className === 'learn') {
            const learnOrder = ['technology', 'economy', 'trusted_computing', 'research', 'token-release', 'whitepaper', 'roadmap', 'brand-resources'];
            const byPathOrLink = (child) => child.pathUrl || (child.link?.split('/').pop() ?? '');
            return learnOrder
                .map((key) => item.childPaths?.find((child) => byPathOrLink(child) === key || (child.pathUrl ?? '').toLowerCase() === key.replace('-', '_')))
                .filter(Boolean);
        }
        return item.childPaths;
    };
    const handleMobileWalletClick = () => {
        if (walletStatus === walletState.connected) {
            setOpenWalletInfo(true);
            return;
        }
        handleConnectWallet();
    };
    const mobileWalletText = walletStatus === walletState.connected
        ? formatAddress(account?.address || '')
        : walletStatus === walletState.wrongNetwork
            ? t('unsupportedNetwork')
            : t('connectWallet');
    const mobileWalletIcon = walletStatus === walletState.connected ? getCurrentNetworkIcon() : walletStatus === walletState.wrongNetwork ? WrongPNG : WalletPNG;
    return (_jsxs(_Fragment, { children: [_jsx(PcShowContainter, { children: _jsxs(StyledNav, { className: scrolled ? 'head-nav blur' : 'head-nav', children: [_jsx(Logo, { onClick: () => {
                                history.push('/');
                            } }), _jsx(AccountModel, { isOpen: openWalletInfo, onDismiss: () => setOpenWalletInfo(false) }), _jsxs("span", { className: 'nav-con', children: [_jsx("div", { className: 'nav-con-left', children: _jsx(NavCon, { children: NavRouter.map(({ isHot, name, pathUrl, link, childPaths, comingSoon, onCheck, clickLabel, newWindow, target, className }) => {
                                            if (childPaths) {
                                                return (_jsxs(StyledDropdown, { className: childPaths.some(({ pathUrl }) => pathUrl && pathnameMatchesSlug(location.pathname, pathUrl)) ? 'active' : '', children: [name, _jsx(PointDown, {}), _jsx(Dropdown, { className: className ? className : '', children: childPaths.map(({ name, pathUrl, link, introText, comingSoon, isHot, onCheck, target, showRightPoint }) => {
                                                                return link ? (_jsxs(ExternalLink, { href: link, target: target, children: [_jsxs("i", { className: "dropdown-title", children: [name, isHot && _jsx(HartGif, { src: hartGif, alt: "" }), showRightPoint && _jsx(PointRight, { className: 'jump' })] }), introText && _jsx(IntroText, { children: introText })] }, name)) : pathUrl ? (_jsxs(NavLink, { to: `/${pathUrl}`, className: comingSoon ? 'comingSoon' : 'jumplinkDOm', children: [_jsxs("i", { className: "dropdown-title", children: [name, isHot && _jsx(HartGif, { src: hartGif, alt: "" }), showRightPoint && _jsx(PointRight, { className: 'jump' })] }), introText && _jsx(IntroText, { children: introText })] }, name)) : onCheck ? (_jsx("span", { className: onCheck ? 'checkBtn' : '', children: name })) : (_jsxs("span", { className: comingSoon ? 'comingSoon' : '', children: [_jsxs("i", { className: "dropdown-title", children: [name, showRightPoint && _jsx(PointRight, { className: 'jump' })] }), introText && _jsx(IntroText, { children: introText })] }));
                                                            }) })] }, name));
                                            }
                                            return (_jsx(_Fragment, { children: link ? (_jsx(ExternalHeaderLink, { target: target, href: link, children: name }, name)) : pathUrl ? (_jsx(StyledNavLink, { to: '/' + pathUrl, className: pathnameMatchesSlug(location.pathname, pathUrl) ? 'active' : '', ...(newWindow ? { target: "_blank" } : {}), children: name }, name)) : (_jsxs(StyledNavLinkSoon, { className: comingSoon ? 'comingSoon' : '', children: [name, _jsx("div", { className: name === 'AI' ? 'comingSonTips comingSonTipsAI' : 'comingSonTips', children: "Coming Soon" })] }, name)) }));
                                        }) }) }), _jsxs(LangDropdown, { onMouseEnter: () => setLangOpen(true), onMouseLeave: () => setLangOpen(false), children: [_jsxs(LangDropdownTrigger, { type: "button", "aria-expanded": langOpen, onClick: () => setLangOpen((open) => !open), children: [_jsx(LangGlobeIcon, {}), currentLang === 'ja' ? '日本語' : 'English', _jsx(LangChevron, { "$open": langOpen })] }), _jsxs(LangDropdownMenu, { "$open": langOpen, children: [_jsx(LangDropdownItem, { type: "button", "$active": currentLang === 'en', onClick: () => { switchLang('en'); setLangOpen(false); }, children: "English" }), _jsx(LangDropdownItem, { type: "button", "$active": currentLang === 'ja', onClick: () => { switchLang('ja'); setLangOpen(false); }, children: "\u65E5\u672C\u8A9E" })] })] }), walletStatus === walletState.disconnected ? (_jsxs(ConnectWalletBtn, { onClick: handleConnectWallet, children: [_jsx("img", { src: WalletPNG, alt: "" }), t('connectWallet')] })) : walletStatus === walletState.wrongNetwork ? (_jsxs(WrongNetworkBtn, { onClick: handleConnectWallet, children: [_jsx("img", { src: WrongPNG, alt: "" }), t('unsupportedNetwork')] })) : (_jsxs(ConnectedWalletBtn, { onClick: () => setOpenWalletInfo(true), children: [_jsx(ChainIcon, { src: getCurrentNetworkIcon(), alt: "" }), _jsx(AddressText, { children: formatAddress(account?.address || '') })] }))] })] }) }), _jsxs(MobileShowContainer, { children: [_jsxs(StyleMobileNav, { className: scrolled ? 'blur' : '', children: [_jsx(NavLogo, { onClick: () => {
                                    history.push('/');
                                } }), _jsxs(MobileHeaderActions, { children: [_jsxs(MobileLangDropdown, { onMouseEnter: () => setMobileLangOpen(true), onMouseLeave: () => setMobileLangOpen(false), children: [_jsxs(MobileLangTrigger, { type: "button", "aria-expanded": mobileLangOpen, onClick: () => setMobileLangOpen((open) => !open), children: [_jsx(LangGlobeIcon, {}), currentLang === 'ja' ? '日本語' : 'EN', _jsx(LangChevron, { "$open": mobileLangOpen })] }), _jsxs(MobileLangMenu, { "$open": mobileLangOpen, children: [_jsx(MobileLangItem, { type: "button", "$active": currentLang === 'en', onClick: () => { switchLang('en'); setMobileLangOpen(false); }, children: "English" }), _jsx(MobileLangItem, { type: "button", "$active": currentLang === 'ja', onClick: () => { switchLang('ja'); setMobileLangOpen(false); }, children: "\u65E5\u672C\u8A9E" })] })] }), _jsxs(MobileWalletButton, { type: "button", onClick: handleMobileWalletClick, children: [mobileWalletIcon && _jsx("img", { src: mobileWalletIcon, alt: "" }), _jsx("span", { children: mobileWalletText })] }), _jsxs(MenuShow, { type: "button", "aria-label": "Open navigation", onClick: openMobileMenu, children: [_jsx("span", {}), _jsx("span", {}), _jsx("span", {})] })] })] }), _jsx(Drawer, { closable: false, onClose: closeMobileMenu, open: showMennu, height: '100%', width: '100%', rootClassName: "mobile-nav-drawer-root", className: "mobile-nav-drawer", headerStyle: { background: '#0A194A', display: 'none' }, children: _jsx(MobilWrapper, { children: _jsxs("div", { className: "menuList", children: [_jsxs(MobileMenuHeader, { children: [_jsx(MobileDrawerLogo, { alt: "NetX Logo", src: LogoPng, onClick: () => {
                                                    history.push('/');
                                                    closeMobileMenu();
                                                } }), _jsx(MobileCloseButton, { type: "button", "aria-label": "Close navigation", onClick: closeMobileMenu })] }), _jsx(MobileMenuList, { children: NavRouterList.map((item, index) => {
                                            const childPaths = getMobileChildPaths(item);
                                            const hasChildren = childPaths.length > 0;
                                            return (_jsxs(MobileMenuSection, { children: [hasChildren ? (_jsxs(MobileMenuToggle, { type: "button", onClick: () => toggleMobileMenuItem(index), children: [_jsx("span", { children: item.name }), _jsx(MobileChevron, { "$open": !!item.flag })] })) : item.link ? (_jsx(MobileMenuExternal, { href: item.link, target: item.target ? item.target : '_blank', rel: "noopener noreferrer", onClick: closeMobileMenu, children: item.name })) : (_jsx(MobileMenuLink, { to: `/${item.pathUrl || ''}`, onClick: closeMobileMenu, children: item.name })), hasChildren && item.flag && (_jsx(MobileSubMenu, { children: childPaths.map((_item) => {
                                                            const title = (_jsxs(_Fragment, { children: [_jsxs(MobileChildTitle, { children: [_item.name, _item.showRightPoint && _jsx(MobileJumpArrow, {})] }), _item.introText && _jsx(MobileChildIntro, { children: _item.introText })] }));
                                                            if (_item.link) {
                                                                return (_jsx(MobileChildExternal, { href: _item.link, target: _item.target ? _item.target : '_blank', rel: "noopener noreferrer", onClick: closeMobileMenu, children: title }, _item.name));
                                                            }
                                                            if (_item.pathUrl) {
                                                                return (_jsx(MobileChildLink, { to: `/${_item.pathUrl}`, onClick: closeMobileMenu, children: title }, _item.name));
                                                            }
                                                            return (_jsx(MobileChildPlaceholder, { children: title }, _item.name));
                                                        }) }))] }, item.name));
                                        }) })] }) }) })] })] }));
}
const StyledNav = styled.div `
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-family: var(--netx-font);
  left: 0;
  right: 0;
  top: 0;
  height: 88rem;
  padding: 0 40rem;
  position: fixed;
  z-index: 88;
  &.blur{
    background: none;
    backdrop-filter: blur(20rem);
  }
  >span{
    display: flex;
    align-items: center;
    flex:1;
    justify-content: space-between;
    .nav-con-left{
      flex: 1;
    }
  }
`;
const LanchButton = styled.div `
  width: 142rem;
    height: 40rem;
    border: 2rem solid #2E6AFF;
    /* background: linear-gradient(0deg, rgb(91, 130, 255) 0%, rgb(4, 60, 247) 45%, rgb(96, 134, 255) 100%); */
    border-radius: 20rem;
    font-family: var(--netx-font);
    font-weight: 500;
    font-size: 16rem;
    color: rgb(255, 255, 255);
    line-height: 16rem;
    text-align: center;
    font-style: normal;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 24rem;
`;
const Logo = styled.div `
  width: 130rem;
  height: 88rem;
  background: url(${LogoPng});
  background-size: 100% 100%;
  cursor: pointer;
`;
const PointDown = styled.span `
display: inline-block;
  width: 16rem;
  height: 16rem;
  margin-left: 4rem;
  background: url(${down});
  background-size: 100% 100%;
`;
const PointRight = styled.div `
  display: inline-block;
  width: 16rem;
  height: 16rem;
  margin-left: 8rem;
  background: url(${jump});
  background-size: 100% 100%;

`;
const NavCon = styled.div `
  height:80rem;
  align-items: center;
  display: flex;
  justify-content: center;
  font-family: var(--netx-font);
  >div{
    height:80rem;
    align-items: center;
  display: flex;
  &:hover{
    >span{
      transform: rotate(180deg);
      background-size: 100% 100%;
    }
  }
  }
  >a{
    height:80rem;
     &:nth-child(4){
      position: relative;
     
    }
  }
 

  >a{
    font-size: 16rem;
    font-family: var(--netx-font);
    font-weight: 500;
    color: #FFFFFF;
    -webkit-align-items: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    outline: none;
    cursor: pointer;
    -webkit-text-decoration: none;
    text-decoration: none;
    width: -webkit-fit-content;
    width: -moz-fit-content;
    width: fit-content;
    white-space: nowrap;
    -webkit-transition: 0.5s;
    transition: 0.5s;
    padding: 0 28rem;
    margin-right: 16rem;
    display: flex;
    align-items: center;
    position: relative;
    isolation: isolate;
    &::before{
      content: '';
      position: absolute;
      left: 0rem;
      right: 0rem;
      top: 50%;
      height: 48rem;
      border: 1rem solid transparent;
      border-radius: 24rem;
      background: radial-gradient(120% 140% at 50% 120%, rgba(255, 255, 255, 0.28) 0%, rgba(255, 255, 255, 0.1) 34%, rgba(16, 31, 66, 0.72) 72%) padding-box,
        linear-gradient(180deg, rgba(82, 95, 129, 0.62) 0%, rgba(19, 34, 72, 0.82) 52%, rgba(16, 31, 66, 0.78) 100%) padding-box,
        linear-gradient(150deg, rgba(255, 255, 255, 0.4), rgba(198, 198, 198, 0), rgba(151, 151, 151, 1)) border-box;
      box-shadow: inset 0px 0px 18px 0px rgba(255,255,255,0.42), 0 2rem 8rem rgba(0, 0, 0, 0.18);
      opacity: 0;
      transform: translateY(-50%);
      transition: opacity 0.3s;
      z-index: -1;
      pointer-events: none;
    }
    &.active{
      color: #FFFFFF;
      &::before{
        opacity: 1;
      }
    }
    &:hover{
      color: #FFFFFF;
      &::before{
        opacity: 1;
      }
    }
   
   
  }
  
`;
const StyledDropdown = styled.div `
  font-size: 16rem;
  font-family: var(--netx-font);
  font-weight: 500;
  color: #fff;
  padding: 0 28rem;
  align-items: center;
  outline: none;
  cursor: pointer;
  text-decoration: none;
  width: fit-content;
  height: 80rem;
  position: relative;
  display: flex;
  align-items: center;
  isolation: isolate;
  margin-right: 16rem;
  &::before{
    content: '';
    position: absolute;
    left: 0rem;
    right: 0rem;
    top: 50%;
    height: 48rem;
    border: 1rem solid transparent;
    border-radius: 24rem;
    background: radial-gradient(120% 140% at 50% 120%, rgba(255, 255, 255, 0.28) 0%, rgba(255, 255, 255, 0.1) 34%, rgba(16, 31, 66, 0.72) 72%) padding-box,
      linear-gradient(180deg, rgba(82, 95, 129, 0.62) 0%, rgba(19, 34, 72, 0.82) 52%, rgba(16, 31, 66, 0.78) 100%) padding-box,
      linear-gradient(150deg, rgba(255, 255, 255, 0.4), rgba(198, 198, 198, 0), rgba(151, 151, 151, 1)) border-box;
    box-shadow: inset 0px 0px 18px 0px rgba(255,255,255,0.42), 0 2rem 8rem rgba(0, 0, 0, 0.18);
    opacity: 0;
    transform: translateY(-50%);
    transition: opacity 0.3s;
    z-index: -1;
    pointer-events: none;
  }
  &.active{
    color: #FFFFFF;
    &::before{
      opacity: 1;
    }
    > span {
      background-size: 100% 100%;
    }
  }
  >img {
    width: 14rem;
    height: 14rem;
    margin-left: 8rem;
  }
  >span {
    transition: 0.3s;
  }
  > div {
    display: none;
    top: 74rem;
    height: auto;
    &.build{
      left: -16rem;
    }
    &.participate{
      left: -16rem;
    }
    &.learn{
      left: 50%;
      transform: translateX(-50%);
    }

  }
 

  &:hover,
  &:focus {
    color: #FFFFFF;
    &::before{
      opacity: 1;
    }

    .down {
      transform: rotate(180deg);
      color: #FFFFFF;
    }
    && > span {
      background-size: 100% 100%;
    }
    & > div {
      display: flex;
      transition: all 0.5s;
      pointer-events: auto;
    }
    & > div.learn {
      display: grid;
    }
  }
`;
const Dropdown = styled.div `
background: linear-gradient( 180deg, #101D42 0%, #101B3A 100%);
box-shadow: inset 0px 1rem 7rem 0rem rgba(255,255,255,0.09);
/* background: rgba(7, 18, 51, 0.72); */
/* border: 1rem solid rgba(74, 96, 151, 0.28); */
/* box-shadow: inset 0px 0px 22rem rgba(255, 255, 255, 0.03), 0 18rem 42rem rgba(0, 0, 0, 0.18); */
backdrop-filter: blur(20rem);
  z-index: 3;
  position: absolute;
  border-radius: 8rem;
  display: flex;
  flex-direction: column;
  gap: 0;
  padding: 28rem;
  width: 370rem;
  &.learn{
    width: 986rem;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    column-gap: 28rem;
    padding: 40rem;
  }
  a,
  span {
    color: #fff;
    text-decoration: none;
    display: block;
    position: relative;
    width: 100%;
    font-family: var(--netx-font);
    font-size: 16rem;
    padding: 0 0 24rem;
    margin-bottom: 24rem;
    border-bottom: 1rem solid rgba(255, 255, 255, 0.1);
    &:nth-last-child(-n + 1) {
      border-bottom: none;
      margin-bottom: 0;
      padding-bottom: 0;
    }
    .dropdown-title {
      display: flex;
      align-items: center;
      gap: 8rem;
      font-style: normal;
      font-size: 16rem;
      line-height: 20rem;
      font-weight: 600;
      color: #FFFFFF;
      margin-bottom: 8rem;
    }
    .jump {
      flex: none;
      width: 14rem;
      height: 14rem;
    }
    .dropdown-title + div {
      display: block;
      font-family: var(--netx-font);
      font-size: 14rem;
      font-weight: 500;
      line-height: 22rem;
      color: rgba(255, 255, 255, 0.54);
      white-space: normal;
      padding: 0;
    }
    &:hover {
      color: #FFFFFF;
      .dropdown-title {
        color: #1A69FF;
      }
      .jump{
        background: url(${jump_hover});
        background-size: 100% 100%;
      }
    }
    &.checkBtn {
      color: #111112;
    }

    &.comingSoon {
      color: rgba(153, 153, 153, 1);
      cursor: not-allowed;
    }
  
  }
  &.learn a,
  &.learn span {
    &:nth-last-child(-n + 2) {
      border-bottom: 1rem solid rgba(255, 255, 255, 0.1);
      margin-bottom: 24rem;
      padding-bottom: 24rem;
    }
    &:nth-child(6),
    &:nth-child(7) {
      border-bottom: none;
      margin-bottom: 0;
      padding-bottom: 0;
    }
  }
  a img {
    width: 28rem;
    height: 28rem;
    position: relative;
    top: -5rem;
  }
`;
const StyledNavLink = styled(NavLink) `
  font-size: 16rem;
  font-family: var(--netx-font);
  font-weight: 500;
  color: #ffffff;
  align-items: center;
  outline: none;
  cursor: pointer;
  text-decoration: none;
  width: fit-content;
  white-space: nowrap;
  transition: 0.5s;
  /* margin-right: 56rem; */
  padding: 0 28rem;
  &:hover {
    color: #fff;
  }
`;
const StyledNavLinkSoon = styled.span `
  display: flex;
  height: 80rem;
  font-size: 16rem;
  font-family: var(--netx-font);
  font-weight: 500;
  color: #ffffff;
  align-items: center;
  outline: none;
  cursor: pointer;
  text-decoration: none;
  width: fit-content;
  white-space: nowrap;
  transition: 0.5s;
  /* margin-right: 56rem; */
  padding: 0 28rem;
  position: relative;
  .comingSonTips {
    position: absolute;
    padding: 3rem 5rem;
    background: rgba(255, 255, 255, 0.15);
    border-radius: 4rem;
    font-size: 12rem;
    font-family: var(--netx-font);
    font-weight: 400;
    color: #ffffff;
    display: none;
    left: -50%;
    top: 64rem;
  }
  .comingSonTipsAI {
    left: -35rem;
  }
  &:hover {
    /* color: #fff; */
    .comingSonTips {
      display: block;
    }
  }
`;
const IntroText = styled.div `
  font-size: 12rem;
  font-family: var(--netx-font);
  font-weight: 400;
  white-space: wrap;
  color: #A2A2A2;
  line-height: 14rem;
  padding: 12rem 16rem 20rem 0;


`;
const ShowText = styled.div `
  display: flex;
  font-family: var(--netx-font);
font-weight: 500;
font-size: 14rem;
color: #FFFFFF;
line-height: 14rem;
>img{
  width: 16rem;
  height: 16rem;
  margin-left: 8rem;
}

`;
const StyleMobileNav = styled.div `
  width: 100%;
  height: 54rem;
  display: flex;
  font-family: var(--netx-font);
  padding: 0 16rem 0 16rem;
  align-items: center;
  justify-content: space-between;
  background: transparent;
  transition: background 0.3s ease, backdrop-filter 0.3s ease;
  &.blur {
    background: rgba(16, 29, 66, 0.82);
    backdrop-filter: blur(20rem);
  }
`;
const NavLogo = styled.div `
  width: 77rem;
  height: 42rem;
  background: url(${mobileLogo});
  background-size: 100% 100%;
  cursor: pointer;
`;
const MobileHeaderActions = styled.div `
  display: flex;
  align-items: center;
  gap: 8rem;
`;
const MobileWalletButton = styled.button `
  height: 32rem;
  max-width: 151rem;
  padding: 0 8rem;
  border: 1rem solid rgba(255, 255, 255, 0.92);
  border-radius: 999rem;
  background: #FFFFFF;
  color: #09090B;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4rem;
  font-family: var(--netx-font);
  font-size: 15rem;
  font-weight: 500;
  line-height: 10rem;
  white-space: nowrap;
  overflow: hidden;
  cursor: pointer;

  img {
    width: 20rem;
    height: 20rem;
    flex: none;
    border-radius: 50%;
  }

  span {
    text-overflow: ellipsis;
  }
`;
const MenuShow = styled.button `
  width: 24rem;
  height: 24rem;
  padding: 0;
  border: none;
  background: transparent;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4rem;
  cursor: pointer;

  span {
    display: block;
    width: 16rem;
    height: 2rem;
    border-radius: 999rem;
    background: #FFFFFF;
  }
`;
const MobilWrapper = styled.div `
  width: 100%;
  min-height: 100vh;
  font-family: var(--netx-font);
  background: #101D42;
  color: #FFFFFF;
  .menuList {
    width: 100%;
    min-height: 100vh;
    background: #101D42;
    padding: 0 24rem 56rem;
    overflow-y: auto;
    scrollbar-width: none;
    -ms-overflow-style: none;

    &::-webkit-scrollbar {
      display: none;
    }

    @media screen and (min-width: 1021rem) {
      display: none;
    }
  }
`;
const MobileMenuHeader = styled.div `
  height: 72rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;
const MobileDrawerLogo = styled.img `
  width: 64rem;
  height: 36rem;
  object-fit: contain;
  cursor: pointer;
`;
const MobileCloseButton = styled.button `
  position: relative;
  width: 24rem;
  height: 24rem;
  padding: 0;
  border: none;
  background: transparent;
  cursor: pointer;

  &::before,
  &::after {
    content: '';
    position: absolute;
    left: 4rem;
    top: 11rem;
    width: 17rem;
    height: 2rem;
    border-radius: 999rem;
    background: #FFFFFF;
  }

  &::before {
    transform: rotate(45deg);
  }

  &::after {
    transform: rotate(-45deg);
  }
`;
const MobileMenuList = styled.nav `
  width: 100%;
`;
const MobileMenuSection = styled.div `
  border-bottom: 1rem solid rgba(255, 255, 255, 0.1);
`;
const MobileMenuBase = `
  width: 100%;
  min-height: 77rem;
  padding: 0;
  border: none;
  background: transparent;
  color: #FFFFFF;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-family: var(--netx-font);
  font-size: 16rem;
  font-weight: 500;
  line-height: 20rem;
  text-align: left;
  text-decoration: none;
  cursor: pointer;
`;
const MobileMenuToggle = styled.button `
  ${MobileMenuBase}
`;
const MobileMenuLink = styled(NavLink) `
  ${MobileMenuBase}
`;
const MobileMenuExternal = styled.a `
  ${MobileMenuBase}
`;
const MobileChevron = styled.span `
  width: 0;
  height: 0;
  border-left: 6rem solid transparent;
  border-right: 6rem solid transparent;
  ${({ $open }) => $open ? 'border-bottom: 7rem solid #FFFFFF;' : 'border-top: 7rem solid #FFFFFF;'}
`;
const MobileSubMenu = styled.div `
  width: 100%;

  > * + * {
    padding-top: 24rem;
    border-top: 1rem solid rgba(255, 255, 255, 0.1);

    > div:first-child {
      margin-top: 16rem;
    }
  }
`;
const MobileChildBase = `
  display: block;
  width: 100%;
  padding: 0 0 24rem;
  margin: 0;
  color: #FFFFFF;
  text-decoration: none;
  cursor: pointer;
`;
const MobileChildLink = styled(NavLink) `
  ${MobileChildBase}
`;
const MobileChildExternal = styled.a `
  ${MobileChildBase}
`;
const MobileChildPlaceholder = styled.div `
  ${MobileChildBase}
  cursor: default;
`;
const MobileChildTitle = styled.div `
  display: flex;
  align-items: center;
  gap: 8rem;
  font-family: var(--netx-font);
  font-size: 15rem;
  font-weight: 500;
  line-height: 18rem;
  color: #FFFFFF;
`;
const MobileChildIntro = styled.div `
  margin-top: 10rem;
  font-family: var(--netx-font);
  font-size: 12rem;
  font-weight: 400;
  line-height: 15rem;
  color: rgba(255, 255, 255, 0.6);
`;
const MobileJumpArrow = styled.span `
  display: inline-block;
  width: 14rem;
  height: 14rem;
  background: url(${jump});
  background-size: 100% 100%;
  flex: none;
`;
const LineText = styled.div `
  font-size: 16rem;
  font-family: var(--netx-font);
  font-weight: 500;
  color: #ffffff;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 76rem;
  img {
    width: 12rem;
    height: 12rem;
    &.up{
      transform: rotate(180deg);
    }
  }
  .blue{
    color: #5585FC;
  }
  >a,>span{
    color: #fff;
    padding: 0;
    margin: 0;
    font-family: var(--netx-font);
        font-weight: 500
  }
  .showItem{
    display: block;
    width: 100%;
    height: 100%;
    line-height: 76rem;
  }
  .commingSoon{
    position: relative;
    >span{
      font-size: 12rem;
      font-family: var(--netx-font);
      font-weight: 400;
      color: #FFFFFF;
      padding: 3rem 5rem;
      background: rgba(255, 255, 255, 0.15);
      border-radius: 4rem;
      margin-left: 8rem;
    }
  }
`;
const MenuList = styled.div `
  width: 100%;
  div{
    width: 100%;
  }
  border-bottom: 1rem solid rgba(255, 255, 255, 0.08);

`;
const ChildCon = styled.div `
  font-size: 16rem;
  font-family: var(--netx-font);
  font-weight: 800;
  color: #ffffff;
`;
const ChildText = styled.div `
  >div {
    font-size: 14rem;
    font-weight: 400;
    color: #ffffff;
    line-height: 14rem;

    a {
      color: #ffffff;
      display: inline-block;
      width: 100%;
      text-decoration: none;
    }
    span {
      padding: 1rem 6rem;
      margin-left: 12rem;
      width: 40rem;
      height: 18rem;
      background: linear-gradient(90deg, #18eac4 0%, #3db2ff 100%);
      border-radius: 2rem;
      font-size: 10rem;
      font-family: var(--netx-font);
      font-weight: 600;
      color: #0d102d;
      line-height: 14rem;
      position: relative;
      top: 0rem;
    }

  }
  p {
    padding-left: 15rem;
    color: rgba(255, 255, 255, 0.3);
  }
  .jumpDom{
    padding: 12rem 0;
  }
`;
// 钱包连接按钮样式
const ConnectWalletBtn = styled.div `
  width: 201rem;
  height: 40rem;
  background: #FFFFFF;
border-radius: 20rem;
border: 1rem solid #FFFFFF;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: var(--netx-font);
  font-weight: 500;
  font-size: 16rem;
  color: #09090B;
  cursor: pointer;

  > img {
    width: 20rem;
    height: 20rem;
    margin-right: 8rem;
  }
`;
const WrongNetworkBtn = styled.div `
  height: 40rem;
  padding: 0 20rem;
  margin-right: 40rem;
  background: #FFFFFF;
  border-radius: 20rem;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: var(--netx-font);
  font-weight: 500;
  font-size: 16rem;
  color: #000000;
  cursor: pointer;

  > img {
    width: 20rem;
    height: 20rem;
    margin-right: 8rem;
  }
`;
const ConnectedWalletBtn = styled.div `
  height: 40rem;
  padding: 0 20rem;
  margin-right: 0rem;
  background: #FFFFFF;
  border-radius: 20rem;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: var(--netx-font);
  font-weight: 500;
  font-size: 14rem;
  color: #000000;
  cursor: pointer;
`;
const ChainIcon = styled.img `
  display: block;
  width: 20rem;
  height: 20rem;
  margin-right: 8rem;
`;
const AddressText = styled.span `
  font-family: var(--netx-font);
  font-weight: 500;
  font-size: 14rem;
  color: #000000;
  line-height: 14rem;
`;
const LangDropdown = styled.div `
  position: relative;
  margin-right: 16rem;
  padding: 8rem 0;
`;
const LangDropdownTrigger = styled.button `
  width: 134rem;
  height: 44rem;
  padding: 0 14rem 0 15rem;
  border: 1rem solid rgba(39, 56, 118, 0.72);
  border-radius: 24rem;
  background: #162553;
  box-shadow: inset 0 1rem 0 rgba(255, 255, 255, 0.06);
  color: #FFFFFF;
  font-family: var(--netx-font);
  font-weight: 500;
  font-size: 16rem;
  line-height: 1;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8rem;
  white-space: nowrap;
  transition: border-color 0.2s, background 0.2s, box-shadow 0.2s;

  &:hover {
    border-color: rgba(64, 91, 184, 0.95);
    background: #1B2D63;
    box-shadow: inset 0 1rem 0 rgba(255, 255, 255, 0.08), 0 6rem 18rem rgba(2, 7, 28, 0.18);
  }
`;
const LangGlobeIcon = styled.span `
  flex: 0 0 auto;
  width: 20rem;
  height: 20rem;
  background-image: url("data:image/svg+xml,%3Csvg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Ccircle cx='10' cy='10' r='8.5' fill='%23fff' fill-opacity='.92'/%3E%3Cpath d='M2.25 9.85h15.5M10 1.75c2.15 2.08 3.25 4.83 3.25 8.25S12.15 16.17 10 18.25C7.85 16.17 6.75 13.42 6.75 10S7.85 3.83 10 1.75Z' stroke='%23162553' stroke-width='1.55' stroke-linecap='round' stroke-linejoin='round'/%3E%3Cpath d='M4.35 4.55c1.3 1.05 3.18 1.7 5.65 1.7s4.35-.65 5.65-1.7M4.35 15.45c1.3-1.05 3.18-1.7 5.65-1.7s4.35.65 5.65 1.7' stroke='%23162553' stroke-width='1.25' stroke-linecap='round'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: center;
  background-size: 100% 100%;
`;
const LangChevron = styled.span `
  flex: 0 0 auto;
  width: 0;
  height: 0;
  border-left: 5rem solid transparent;
  border-right: 5rem solid transparent;
  border-bottom: 0;
  border-top: 6rem solid #FFFFFF;
  transform: ${({ $open }) => $open ? 'rotate(180deg)' : 'rotate(0deg)'};
  transition: transform 0.2s;
`;
const LangDropdownMenu = styled.div `
  display: ${({ $open }) => $open ? 'flex' : 'none'};
  position: absolute;
  top: calc(100% + 2rem);
  left: 50%;
  transform: translateX(-50%);
  flex-direction: column;
  align-items: stretch;
  width: 134rem;
  padding: 6rem 0;
  border: 1rem solid rgba(30, 48, 104, 0.84);
  background: #101C45;
  box-shadow: inset 0 1rem 7rem rgba(255,255,255,0.08), 0 12rem 28rem rgba(2, 7, 28, 0.22);
  border-radius: 6rem;
  overflow: hidden;
  z-index: 10;
`;
const LangDropdownItem = styled.button `
  width: 100%;
  height: 41rem;
  padding: 0 12rem;
  border: none;
  background: transparent;
  color: ${({ $active }) => $active ? '#1F66FF' : '#FFFFFF'};
  font-family: var(--netx-font);
  font-size: 16rem;
  font-weight: ${({ $active }) => $active ? '500' : '600'};
  line-height: 1;
  cursor: pointer;
  text-align: center;
  white-space: nowrap;
  transition: background 0.15s, color 0.15s;

  &:hover {
    background: rgba(31, 102, 255, 0.08);
    color: #1F66FF;
  }
`;
const MobileLangDropdown = styled.div `
  position: relative;
  padding: 6rem 0;
`;
const MobileLangTrigger = styled.button `
  min-width: 94rem;
  height: 36rem;
  padding: 0 11rem;
  border: 1rem solid rgba(39, 56, 118, 0.72);
  border-radius: 20rem;
  background: #162553;
  color: #FFFFFF;
  font-family: var(--netx-font);
  font-weight: 500;
  font-size: 13rem;
  line-height: 1;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6rem;
  white-space: nowrap;

  ${LangGlobeIcon} {
    width: 16rem;
    height: 16rem;
  }

  ${LangChevron} {
    border-left-width: 4rem;
    border-right-width: 4rem;
    border-top-width: 5rem;
  }
`;
const MobileLangMenu = styled.div `
  display: ${({ $open }) => $open ? 'flex' : 'none'};
  position: absolute;
  top: calc(100% + 2rem);
  right: 0;
  flex-direction: column;
  width: 112rem;
  padding: 5rem 0;
  border: 1rem solid rgba(30, 48, 104, 0.84);
  background: #101C45;
  box-shadow: inset 0 1rem 7rem rgba(255,255,255,0.08), 0 10rem 22rem rgba(2, 7, 28, 0.26);
  border-radius: 6rem;
  overflow: hidden;
  z-index: 100;
`;
const MobileLangItem = styled.button `
  height: 36rem;
  padding: 0 12rem;
  border: none;
  background: transparent;
  color: ${({ $active }) => $active ? '#1F66FF' : '#FFFFFF'};
  font-family: var(--netx-font);
  font-size: 13rem;
  font-weight: ${({ $active }) => $active ? '500' : '600'};
  line-height: 1;
  cursor: pointer;
  text-align: center;
  white-space: nowrap;

  &:hover {
    background: rgba(31, 102, 255, 0.08);
    color: #1F66FF;
  }
`;
